import { useMemo } from 'react'

import {
  HEADER_MENU_COLLAPSED_WIDTH_OFFSET,
  HEADER_MENU_EXPANDED_WIDTH_OFFSET,
  HIDE_COMPANY_AND_ADD_BUTTON,
  HIDE_HELP_BUTTON,
  HIDE_SEARCH_BUTTON,
  HIDE_USER_MENU,
  MIN_WIDTH_FOR_HEADER_ELEMENTS,
} from './useLayoutHeaderElementsVisibility.constants'
import { calculateHeaderElementsVisibility } from './useLayoutHeaderElementsVisibility.utils'

export function useLayoutHeaderElementsVisibility({
  collapsed,
  screenWidth,
  userMenuWidth,
}) {
  const headerMenuWidthOffset = collapsed
    ? HEADER_MENU_COLLAPSED_WIDTH_OFFSET
    : HEADER_MENU_EXPANDED_WIDTH_OFFSET

  const {
    [HIDE_COMPANY_AND_ADD_BUTTON]: hideCompanyAndAddButton,
    [HIDE_HELP_BUTTON]: hideHelpButton,
    [HIDE_SEARCH_BUTTON]: hideSearchButton,
    [HIDE_USER_MENU]: hideUserMenu,
  } = useMemo(() => {
    return calculateHeaderElementsVisibility({
      offset: headerMenuWidthOffset,
      rules: MIN_WIDTH_FOR_HEADER_ELEMENTS,
      screenWidth,
      userMenuWidth,
    })
  }, [headerMenuWidthOffset, screenWidth, userMenuWidth])

  return {
    hideCompanyAndAddButton,
    hideHelpButton,
    hideSearchButton,
    hideUserMenu,
  }
}
